var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($("" + id + "> li").length === 1) return;

		$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3

		if (!options) {
			options = {
				loop:false,
				dots: true,
				autoplay: false,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
				autoplayTimeout: 8000,
				autoplayHoverPause: true,
				touchDrag: true,
				mouseDrag: true,
				items: 1,
				nav: true,
				navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
			};
		}
		$owl.owlCarousel(options);
	}
};

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	},

	rowHeight: function () {
		var biggest = 0;
		var number = 0;
		$('.centerBox > * .wrapper').each(function () {
			if($(this).height() > biggest) {
				biggest = $(this).height();
				number++;
			}
		});

		if (number === 1) {
			$('.centerBox').addClass('firstBox');
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.vefverslun = {
	init: function () {
			var $vefverslunBtn = $('li.ele-vefverslun');
		var $a = $('li.ele-vefverslun a');
		$a.click(function () {
			if ($vefverslunBtn.hasClass('open')) {
				var $href = $('li.ele-vefverslun a').attr('href');
				$a.click(function () {
					window.location.href = $href;
				})
			}
		});
	}
};

site.frontpage = {
	init: function() {
		site.frontpage.scroll();
	},

	scroll: function() {
		$('span.scroll span', '.box.scroll').on('click', function() {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-offset
				}, 1000);
				return false;
			}

		});
	}
};

site.formbuilder = {
	init: function() {
		let quantity = document.getElementById('payment')
		if (quantity && quantity.min && quantity.min === '1' && quantity.max && quantity.max === '1') {
			let label = document.getElementsByClassName('quantity');
			if (label) {
				label[0].classList.add('hidden')
			}
			quantity.value = '1';
			quantity.classList.add('hidden');
		}
	}
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.owl.init('#owl');
	site.vefverslun.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	if ($body.is('.formbuilder') && !$body.is('.loggedIn')) {
		site.formbuilder.init();
	}

	//site.layout.rowWrap('.box_social_facebook', '.box_calendar_upcoming', 'centerBox');
	site.layout.rowWrap('.box_social_facebook', '.box_calendarParentevent', 'centerBox');
	site.layout.rowHeight();

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
